export const COMMENT_TYPE_OFFICER = 'officer_comment';
export const COMMENT_TYPE_ASSESSOR = 'assessor_comment';
export const COMMENT_TYPE_DEFICIENCY = 'deficiency_value';



// WEBPACK FOOTER //
// ./src/store/constants.js